import { useEffectOnce } from "@lib-shared/hooks";

type CatchAllProps = {
    onProcess: () => void
}

const CatchAll = (props: CatchAllProps) => {
    const { onProcess } = props;

    useEffectOnce(() => {
        onProcess();
    });

    return null;
}

export default CatchAll;
